import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Rating from "@material-ui/lab/Rating";
import UpdateIcon from "@material-ui/icons/Update";

const RoleItem = (props) => {
  const [role, setRole] = useState({ _id: null, name: "", stars: null });
  const updateRole = props.updateRole;
  const authContext = useContext(AuthContext);
  const history = useHistory();
  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setRole({
      _id: props.role._id,
      name: props.role.name,
      stars: parseInt(props.role.stars),
    });
  }, [props.editing]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #e1e1e1",
        padding: "5px 5px 5px 0px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <p
          style={{
            margin: "0",
            marginRight: "10px",
            padding: "15px 0%",
          }}
        >
          {role.name}
        </p>
        {!props.editing && <Rating value={role.stars} readOnly />}
      </div>
      {props.editing && (
        <>
          <Rating
            value={role.stars}
            onChange={(e) => {
              setRole({ ...role, stars: e.target.value });
            }}
            style={{ marginTop: "5px" }}
          />
          <IconButton
            variant="outlined"
            color="primary"
            style={{ justifySelf: "flex-end" }}
            onClick={(e) => updateRole(e, role)}
          >
            <UpdateIcon />
          </IconButton>
          <IconButton
            variant="outlined"
            color="secondary"
            style={{ justifySelf: "flex-end" }}
            onClick={() => props.removeRole(props.role)}
          >
            <DeleteIcon />
          </IconButton>
        </>
      )}
    </div>
  );
};

export default RoleItem;
